import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { logout } from "../../store/loginReducer";
import { getSession } from "../../common/utils/sessionManager";

const useSessionMonitor = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const role = location.pathname.includes("/student") ? "student" : "admin";
  const { isLoggedIn, user } = useSelector((state) => state.login[role]);
  const channelRef = useRef(null);
  const checkIntervalRef = useRef(null);
  const storedSessionIdRef = useRef(null);

  useEffect(() => {
    if (!isLoggedIn || !user) {
      if (channelRef.current) {
        channelRef.current.close();
        channelRef.current = null;
      }
      if (checkIntervalRef.current) {
        clearInterval(checkIntervalRef.current);
        checkIntervalRef.current = null;
      }
      storedSessionIdRef.current = null;
      return;
    }

    const currentSession = getSession(role);
    if (currentSession && currentSession.email === user.email) {
      storedSessionIdRef.current = currentSession.sessionId;
    }

    const handleLogout = () => {
      dispatch(logout(role));
      navigate(role === "student" ? "/student" : "/admin", { replace: true });
    };

    if (typeof BroadcastChannel !== 'undefined') {
      channelRef.current = new BroadcastChannel('session_channel');
      
      channelRef.current.onmessage = (event) => {
        const { type, email, role: eventRole } = event.data;
        if (type === 'NEW_SESSION' && email === user.email && eventRole === role) {
          const currentSession = getSession(role);
          if (currentSession && storedSessionIdRef.current && currentSession.sessionId !== storedSessionIdRef.current) {
            handleLogout();
          }
        }
      };
    }

    checkIntervalRef.current = setInterval(() => {
      if (!storedSessionIdRef.current) {
        return;
      }
      const session = getSession(role);
      if (!session || session.email !== user.email) {
        return;
      }
      if (session.sessionId && session.sessionId !== storedSessionIdRef.current) {
        handleLogout();
      }
    }, 10000);

    return () => {
      if (channelRef.current) {
        channelRef.current.close();
        channelRef.current = null;
      }
      if (checkIntervalRef.current) {
        clearInterval(checkIntervalRef.current);
        checkIntervalRef.current = null;
      }
    };
  }, [isLoggedIn, user, dispatch, navigate, role]);
};

export default useSessionMonitor;

